export default "__VITE_ASSET__FWCtSV5t__"